// Apple `sub-nav-frosted` — parchment 80% + backdrop-blur, 52px tall.
import type { Route } from "../App";

const TITLES: Record<Route, string> = {
  home: "Sức khoẻ",
  trends: "Xu hướng",
  ask: "Hỏi bác sĩ",
  settings: "Cài đặt"
};

export function SubNav({ route, onNavigate }: { route: Route; onNavigate: (r: Route) => void }) {
  return (
    <div className="apple-frosted sticky top-11 z-40 h-[52px] border-b border-hairline">
      <div className="mx-auto flex h-full max-w-[1440px] items-center justify-between px-6">
        <h1 className="text-tagline">{TITLES[route]}</h1>
        {route !== "ask" && (
          <button
            onClick={() => onNavigate("ask")}
            className="apple-press rounded-pill bg-action px-[22px] py-[9px] text-bodyApple font-normal text-white"
          >
            Hỏi BS
          </button>
        )}
      </div>
    </div>
  );
}
